<template>
    <v-card :title="title" >
        <template slot="extra" v-if="moreUrl">
            <a :href="moreUrl" style="color: #eef0f1">MORE+</a>
        </template>
        <div style="padding: 10px">
            <Carousel autoplay loop style="width: 100%;" dots="outside" arrow="never">
                <CarouselItem v-for="item in list">
                    <router-link :to="item.link" class="image-item" :style="styleFormat" >
                        <img :src="item.src" >
                    </router-link>
                </CarouselItem>
            </Carousel>
        </div>
    </v-card>
</template>

<script>
    import VCard from "./Card";
    export default {
        name: "vImageCard",
        props:['title','list','moreUrl','height'],
        computed:{
            styleFormat(){
                return {
                    height:(this.height - 60) + 'px'
                }
            }
        },
        components:{VCard},
        methods:{
        }
    }
</script>

<style lang="less" scoped>
    .image-item{
        display: block;
        position: relative;
        text-align: center;
        & > img{
            max-width: 100%;
            height: 100%;
            margin: 0 auto;
        }
    }
</style>